import { Row, Col, Typography } from "antd";
const {Text} = Typography;
const ContactInfoField = (props) => {
  const { iconClass, contactInfoFieldValue, emptyDataText } = props;
  return (
    <Row wrap={false} className="align-items-center" gutter={16}>
      <Col flex="18px">
        <div className={`staticIconsSprite contact-details-icons ${iconClass}`}></div>
      </Col>
      <Col flex="auto" className="ms-3">
        {contactInfoFieldValue ? (
          <Text className="text-break">{contactInfoFieldValue}</Text>
        ) : (
          <Text className="hs-color-placeholder-grey fst-italic">{emptyDataText}</Text>
        )}
      </Col>
    </Row>
  );
};
export default ContactInfoField;
